import { GridType, LobbyUiContext } from '@/contexts/LobbyUiContext';
import { ScreenContext } from '@/contexts/ScreenContext';
import { getVHByRem } from '@/utils/commonFunc';
import IconButton from '@mui/material/IconButton';
import { useContext } from 'react';
import { GridModeIcon, ListModeIcon, MiniModeIcon } from '../icon';
export const GridToggle = () => {
    const { grid, toggleGrid } = useContext(LobbyUiContext);
    const { isLandscape } = useContext(ScreenContext);
    const iconSize = isLandscape ? getVHByRem(1.5) : '1.5rem';
    return (
        <IconButton
            onClick={() => toggleGrid()}
            // className="self-align-center"
            sx={{
                '& path': {
                    fill: 'white',
                },
                border: 'solid 1px rgba(255, 255, 255, 0.70)',
                borderRadius: '6px',
                padding: 0,
                width: iconSize,
                height: iconSize,
            }}
        >
            {
                {
                    [GridType.MiniMode]: (
                        <MiniModeIcon width={'100%'} height={'100%'} />
                    ),
                    [GridType.GridMode]: (
                        <GridModeIcon width={'100%'} height={'100%'} />
                    ),
                    [GridType.ListMode]: (
                        <ListModeIcon width={'100%'} height={'100%'} />
                    ),
                }[(grid + 1) % 3]
            }
        </IconButton>
    );
};
